import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { CommentContext } from '../../CommentContext';
import SimpleHoverPopperPopover from '@wix/da-ds/pkg/popper/presets/SimpleHoverPopperPopover';
import ExclusiveAvatar, {
  Props as ExclusiveAvatarProps,
} from './ExclusiveAvatar';
import ExclusiveAvatarOverlay from '../../../CommentBox/lego/ExclusiveAvatarOverlay';
import s from './ExclusiveAvatarWithPopover.scss';

const HOVER_DELAY = 500;

export interface Props extends ExclusiveAvatarProps {
  /** Whether to show the popover on hover */
  withPopover?: boolean;
}

/**
 * ExclusiveAvatar with hover popover that shows ExclusiveAvatarOverlay
 */
const ExclusiveAvatarWithPopover: React.FC<Props> = ({
  withPopover = true,
  deviation,
  className,
  ...props
}) => {
  const isMobile = useContext(MobileContext);
  const { comment } = useContext(CommentContext);

  const shouldShowPopover = withPopover && !isMobile;

  if (!shouldShowPopover) {
    return (
      <ExclusiveAvatar deviation={deviation} className={className} {...props} />
    );
  }

  const PopoverContent = () => {
    return (
      <div className={s['popover-wrapper']}>
        <ExclusiveAvatarOverlay
          deviation={deviation}
          commentedByUser={comment?.user}
        />
      </div>
    );
  };

  return (
    <SimpleHoverPopperPopover
      className={cn(s['popover-root'], className)}
      contentClassName={s['popover-content']}
      popoverContent={<PopoverContent />}
      noPadding={true}
      hoverDelay={HOVER_DELAY}
      showArrow={false}
    >
      <ExclusiveAvatar deviation={deviation} {...props} />
    </SimpleHoverPopperPopover>
  );
};

ExclusiveAvatarWithPopover.displayName = 'ExclusiveAvatarWithPopover';

export default ExclusiveAvatarWithPopover;
